import * as Cookie from "js-cookie";

export default {
	getPlatformURL: function() {
		return Cookie.get("com.senior.portal.url");
	},
	getAppointmentData: function() {
		const g7Token = JSON.parse(Cookie.get(`com.senior.token`) || "{}");
		const nameKey = `${g7Token.access_token}-GPO`;
		const appointmentData = JSON.parse(sessionStorage.getItem(nameKey));
		return appointmentData.payload;
	}
};
